module.exports = __webpack_public_path__ + "img/symbol_10.5f2913c5.png";